import { render, staticRenderFns } from "./caldarTctDialog.vue?vue&type=template&id=d2706e2a&scoped=true&"
import script from "./caldarTctDialog.vue?vue&type=script&lang=js&"
export * from "./caldarTctDialog.vue?vue&type=script&lang=js&"
import style0 from "./caldarTctDialog.vue?vue&type=style&index=0&id=d2706e2a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2706e2a",
  null
  
)

export default component.exports